export default __webpack_public_path__ + "static/media/movies.f2912467.svg";